import { ref } from 'vue';
import { useTask } from '@/ui/concerns';
import { list as getEntityFolderList, EntityFolderQuery } from '@/services/api/resources/entityFolder';

export const useEntityFolderCheck = () => {
  const checkLoading = ref<boolean>(true);
  const checkResult = ref<boolean>(false);

  const entityFolderQuery = (): EntityFolderQuery => ({
    search: '',
    entityItem: [],
    user: [],
    label: [],
  });

  const performCheck = useTask(
    () => getEntityFolderList(entityFolderQuery()),
    listResponse => {
      checkResult.value = listResponse.data.length > 0;
      checkLoading.value = false;
    },
  );

  return {
    checkLoading,
    checkResult,
    performCheck,
  };
};
